import validations from '../utils/validations';

export default class Form {
    constructor(data) {
        this.originalData = data;
        this.setFormData(data);
        this.validationRules = this.getValidationRules(data);
        this.processing = false;
        this.closed = false;
        this.responseMessage = '';
    }

    setFormData(data) {
        Object.keys(data).forEach(field => {
            this[field] = data[field];
        });

        return this;
    }

    getValidationRules(data) {
        const rules = {};

        Object.keys(data).forEach(field => {
            rules[field] = validations[field];
        });

        return rules;
    }

    getRequestData() {
        const data = {};

        Object.keys(this).forEach(field => {
            data[field] = this[field];
        });

        return data;
    }

    post(action, customData) {
        return this.submit('post', action, customData)
    }

    patch(action, customData) {
        return this.submit('patch', action, customData)
    }

    submit(requestType, action, customData) {
        this.processing = true;
        this.responseMessage = '';

        const requestData = _.assign({}, this.getRequestData(), customData);

        return new Promise((resolve, reject) => {
            axios[requestType](action, requestData)
                .then(response => {
                    this.processing = false;
                    resolve(response);
                })
                .catch(({ response }) => {
                    this.processing = false;
                    reject(response);
                })
        });
    }

    handleSuccess(message) {
        this.closed = true;
        this.responseMessage = message;
    }
}
